module.exports = __webpack_public_path__ + "img/20210430_110832.2cc44aef.jpg";